import React from 'react';
import { useTranslation } from 'react-i18next';
import type { UserRole } from '../../types';

interface RoleBadgeProps {
  role: UserRole;
}

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  const { t } = useTranslation();

  const getRoleLabel = () => {
    const roleLabels = {
      admin: t('admin.userManagement.roles.admin', 'Administrateur'),
      bureau: t('admin.userManagement.roles.bureau', 'Bureau'),
      expert: t('admin.userManagement.roles.expert', 'Expert'),
      client: t('admin.userManagement.roles.client', 'Client'),
      banque: t('admin.userManagement.roles.banque', 'Banque')
    };
    return roleLabels[role] || role;
  };

  return (
    <span className={`role-badge role-badge--${role}`}>
      {getRoleLabel()}
    </span>
  );
};